import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-ivory px-5 py-12 sm:py-20" data-id="element-92" data-mp="1hbgu4bwv3v38">
      <div className="mx-auto max-w-2xl" data-id="element-93" data-mp="1cfjfqb55syt3">
        <h2 className="text-center font-serif-display text-2xl font-bold text-navy sm:text-4xl" data-id="element-94" data-mp="1ccncq8egfjxs">
          Frequently asked questions
        </h2>

        <div className="mt-8 divide-y divide-blue/15 border-y border-blue/15" data-id="element-95" data-mp="254726a1n9u88">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} data-id="element-96" data-mp="1v5hjif1xc5qx" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex min-h-[48px] w-full items-center justify-between gap-4 py-4 text-left" data-id="element-97" data-mp="1v4g6i51cl96k">
                  <span className="text-sm font-bold text-navy sm:text-base" data-id="element-98" data-mp="1korwvvda6kod">{faq.question}</span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-blueprint text-blue-deep" data-id="element-99" data-mp="1pls2y6a4rnfh">
                    {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-100" data-mp="1fonfm34jtlx3" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-101" data-mp="11x8qdek1sohl" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-102" data-mp="16oqv8dp6z97u">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-103" data-mp="rzuels92knvm">
                      <p className="pb-4 text-sm leading-relaxed text-navy/75" data-id="element-104" data-mp="n1sv567qemjm">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}